'use client';

interface Props {
  alphaZoneSize: number;
  alphaZoneIsolated: boolean;
  onToggle: () => void;
}

/**
 * Compact alpha-zone isolation toggle for the home-page sidebar. Single
 * clickable header — mirrors PortfolioPanel's collapsed state but never
 * expands (no list to manage; the basket is canonical from /api/alpha-basket
 * or live-recomputed under Blended V).
 */
export function AlphaZonePanel({ alphaZoneSize, alphaZoneIsolated, onToggle }: Props) {
  return (
    <div className="px-5 py-2 border-b border-[#1e293b]">
      <button
        onClick={onToggle}
        className={`flex items-center justify-between w-full cursor-pointer rounded-lg
          ${alphaZoneIsolated ? 'ring-1 ring-amber-500/50 bg-amber-500/5 px-2 -mx-2 py-1.5 -my-1.5' : ''}`}
        title={alphaZoneIsolated ? 'Click to show all stocks' : 'Click to show only the alpha basket'}
      >
        <div className="flex items-center gap-2">
          <label className={`text-[10px] font-semibold uppercase tracking-widest cursor-pointer ${alphaZoneIsolated ? 'text-amber-400' : 'text-[#e2e8f0]'}`}>
            Alpha Zone
          </label>
          {alphaZoneSize > 0 && (
            <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-amber-500/20 text-amber-400 font-semibold tabular-nums">
              {alphaZoneSize}
            </span>
          )}
          {alphaZoneIsolated && (
            <span className="text-[8px] text-amber-400 uppercase tracking-wider">isolated</span>
          )}
        </div>
      </button>
    </div>
  );
}
